import { r2Fetch } from './client';

export interface R2DirectoryCreateParams {
  bucket_id: string;
  directory_name: string;
}

export interface R2DirectoryCreateResponse {
  success: boolean;
}

export async function r2DirectoryCreate(
  params: R2DirectoryCreateParams
): Promise<R2DirectoryCreateResponse> {
  return r2Fetch<R2DirectoryCreateResponse>('/rpc/r2_directory_create', {
    body: params,
  });
}
